import { render, staticRenderFns } from "./CircleIcon.vue?vue&type=template&id=79becdc4"
import script from "./CircleIcon.vue?vue&type=script&lang=js"
export * from "./CircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports